import PubNub from 'pubnub';
import { getDeviceId } from "../utils/commonUtil";

export const subscribeToPubNub = (transactionId, insuranceType, navigate) => {
	if (!transactionId) return;

	const deviceId = getDeviceId();
	console.log(deviceId)
	const pubnub = new PubNub({
		subscribeKey: process.env.REACT_APP_SUBSCRIB_KEY,
		uuid: transactionId,
	});

	const channel = `uld-${deviceId}-${transactionId}`;
	pubnub.subscribe({ channels: [channel] });

	console.log("Subscribed to channel:", channel);
	return pubnub;
	// pubnub.addListener({
	// 	message: (event) => {
	// 		console.log('Message received:', event.message);
	// 		return event.message
	// 		// redirect to /completed and pass data as state
	// 		// navigate('/completed', { state: { data: event.message, insuranceType } });
	// 	},
	// 	status: (statusEvent) => {
	// 		console.log("PubNub status:", statusEvent);
	// 	},
	// });
};
